import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "left_menu" }

import { reactive } from 'vue'
    import { useStore } from "vuex";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['clickChild'],
  setup(__props, { emit: __emit }) {

    const store = useStore()
    const data = reactive({
        index: '1'
    })

    const emit = __emit

    const clickChild=(index:string)=>{
        data.index = index
        emit('clickChild',index)
    }

    const user= reactive({
        userInfo: {} as any,
    })
    user.userInfo = store.state.userInfomation
    // user.userInfo = {
    //     "userName": "王宝山",
    //     "certNo": "410928196304039633",
    //     "userType": "2",
    //     "userMobile": "17788100338",
    //     "corpType": "C01",
    //     "certificateSno": "91410223MA40GEQL7N",
    //     "corpName": "尉氏县瑞隆置业有限公司",
    // }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["tit", {'active':data.index === '1'}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickChild('1')))
    }, "我的办件", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["tit", {'active':data.index === '2'}]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (clickChild('2')))
    }, "我的信息", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["tit", {'active':data.index === '3'}]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (clickChild('3')))
    }, "我的证照", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["tit", {'active':data.index === '4'}]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (clickChild('4')))
    }, "我的邮递", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["tit", {'active':data.index === '5'}]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (clickChild('5')))
    }, "我的咨询", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["tit", {'active':data.index === '6'}]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (clickChild('6')))
    }, "我的投诉", 2),
    (user.userInfo.userType == '2')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: _normalizeClass(["tit", {'active':data.index === '7'}]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (clickChild('7')))
        }, "在线填报", 2))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      class: _normalizeClass(["tit", {'active':data.index === '8'}]),
      onClick: _cache[7] || (_cache[7] = ($event: any) => (clickChild('8')))
    }, "零跑智勘", 2),
    (user.userInfo.extend1 == '1')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: _normalizeClass(["tit", {'active':data.index === '9'}]),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (clickChild('9')))
        }, "新闻发布", 2))
      : _createCommentVNode("", true)
  ]))
}
}

})